module.exports = __webpack_public_path__ + "img/Photographer.436dc17c.jpg";